import React, { useState } from "react";

import { Table, AdminListing, Form } from "../components";

const PropertyHead = () => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.Data>Name</Table.Data>
        <Table.Data>Price (Ksh)</Table.Data>
        <Table.Data>Category</Table.Data>
        <Table.Data>Listed In</Table.Data>
        <Table.Data>County</Table.Data>
        <Table.Data>Town</Table.Data>
        <Table.Data>Action</Table.Data>
      </Table.Row>
    </Table.Head>
  );
};
const PropertyData = ({ property, setSelectId }) => {
  const [selected, setSelected] = useState(false);

  const handleSelect = (id) => {
    setSelected((prevState) => !prevState);
    setSelectId(id);
  };

  return (
    <Table.Row>
      <Table.Data>{property.name}</Table.Data>
      <Table.Data>{property.price}</Table.Data>
      <Table.Data>{property.category}</Table.Data>
      <Table.Data>{property.listed}</Table.Data>
      <Table.Data>{property.state}</Table.Data>
      <Table.Data>{property.town}</Table.Data>
      <Table.Data>
        <Table.Button onClick={() => handleSelect(property.id)}>
          {selected ? "Selected" : "Select"}
        </Table.Button>
      </Table.Data>
    </Table.Row>
  );
};

const AdminListingHeader = ({ selectId, handleDeleteAction }) => {
  return (
    <AdminListing.Header>
      <Form>
        <Form.Input type="text" placeholder="Search" />
      </Form>
      <AdminListing.Action>
        <AdminListing.Button
          onClick={() => handleDeleteAction(selectId)}
          bg="var(--bs-danger)">
          Delete
        </AdminListing.Button>
        <AdminListing.Button bg="#25408f">
          <AdminListing.Anchor to={selectId && `/add-listing/${selectId}`}>
            Edit
          </AdminListing.Anchor>
        </AdminListing.Button>
        <AdminListing.Button bg="#25408f">
          <AdminListing.Anchor to={selectId && `/property/${selectId}`}>
            View
          </AdminListing.Anchor>
        </AdminListing.Button>
      </AdminListing.Action>
    </AdminListing.Header>
  );
};

export { AdminListingHeader, PropertyHead, PropertyData };
